import "antd/dist/antd.css";
import "../App.css";

import GuideCard from "../components/GuideCard";
import CtaCard from "../components/CtaCard";
import usePageMeta from "../usePageMeta";
import { GUIDES } from "../data/guides";

function GuidesIndex() {
    usePageMeta({
        title: "Guides — Planamoto",
        description:
            "Practical guides for motorbike touring: what to pack for Europe, how to use French toll roads, and more. Written for UK riders heading abroad.",
        url: "https://www.planamoto.com/guides",
    });

    return (
        <article className="gt-guide-article gt-guide-article--wide">
            <div className="gt-eyebrow">Guides</div>
            <h1 className="gt-h1 gt-guide-article__title">Guides for the road</h1>
            <p className="gt-guide-article__lede">
                Practical pieces for riders heading abroad: what to pack, how the
                tolls work, what each country expects on the bike. Written by
                riders who've made the mistakes so you don't have to.
            </p>

            <div className="gt-grid--cards gt-guides-index__grid">
                {GUIDES.map((guide) => (
                    <GuideCard
                        key={guide.slug}
                        to={`/guides/${guide.slug}`}
                        eyebrow={`Guide · ${guide.readingTime}`}
                        title={guide.title}
                        body={guide.summary}
                        image={guide.image}
                        icon={guide.icon}
                        accentColor={guide.accentColor}
                    />
                ))}
            </div>

            <CtaCard
                title="Planning the route?"
                body="Our hand-curated tour templates cover the WWII beaches in Normandy, the Alps via Stelvio, the Wild Atlantic Way and more. Clone one as your starting point."
                primary={{ label: "Browse tours", to: "/explore" }}
            />
        </article>
    );
}

export default GuidesIndex;
